export default __webpack_public_path__ + "static/rares-banescu-fb39990c700c24ef9722a71f4064ad8c.svg";